import React, { useState } from "react";
import { Form, Input } from "antd";
import "../styles/LoginStyles.css";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import agalogo from "../assets/aga.jpg";
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  ReloadOutlined,
} from "@ant-design/icons";

import { Tooltip } from "antd";

const Login = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    email: "",
    password: "",
    showPassword: false,
  });
  const { email, password } = inputs;

  const onChange = (e) =>
    setInputs({ ...inputs, [e.target.name]: e.target.value });

  // const generatePasswordAndSet = (length) => {
  //   const charset =
  //     "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+~`|}{[]:;?><,./-=";
  //   let generated = "";
  //   for (let i = 0, n = charset.length; i < length; ++i) {
  //     generated += charset.charAt(Math.floor(Math.random() * n));
  //   }
  //   setInputs((prev) => ({ ...prev, password: generated }));
  // };

  const onSubmitForm = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );

      const parseRes = await response.json();
      if (parseRes.success === true) {
        toast.success(parseRes.message);
        localStorage.setItem("token", parseRes.data);
        navigate("/dashboard");
      } else {
        toast.error(parseRes.message);
      }
    } catch (error) {
      toast.error("Login failed");
    }
  };

  return (
    <div className="form-wrapper">
      <div className="login-card">
        <img
          style={{
            height: "70px",
            marginBottom: "20px",
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
          }}
          src={agalogo}
        />
        <h2 className="form-title">Se Connecter à ESIA</h2>
        <Form layout="vertical" onFinish={onSubmitForm} className="form-body">
          <Form.Item label="Email" name="email" required>
            <Input
              type="email"
              name="email"
              value={email}
              onChange={onChange}
              placeholder="Entrer votre email"
            />
          </Form.Item>

          <Form.Item label="Mot de passe" required>
            <Input.Password
              name="password"
              value={password}
              onChange={onChange}
              placeholder="Entrer votre mot de passe"
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
              visibilityToggle={{
                visible: inputs.showPassword,
                onVisibleChange: (visible) =>
                  setInputs((prev) => ({ ...prev, showPassword: visible })),
              }}
            />
          </Form.Item>

          <Link to="/forgot-password" className="forgot-link">
            Mot de passe oublié ?
          </Link>
          {/* <button
            type="button"
            onClick={() => generatePasswordAndSet(20)}
            className="btn btn-secondary full-width"
          >
            Générer un mot de passe
          </button> */}

          <button type="submit" className="btn btn-primary full-width">
            Connexion
          </button>
        </Form>
      </div>
    </div>
  );
};

export default Login;
